import qs from 'qs';
import { AUTHORIZE_URL } from '../constants';
export function getAuthorizationUrl(clientId, redirectUri, responseType, options) {
    return `${AUTHORIZE_URL}?${qs.stringify(Object.assign(Object.assign(Object.assign({}, options), { client_id: clientId, redirect_uri: redirectUri, response_type: responseType }), ((options === null || options === void 0 ? void 0 : options.scope) && { scope: options.scope.join(' ') })))}`;
}
//# sourceMappingURL=getAuthorizationUrl.js.map